module.exports = __webpack_public_path__ + "img/casas-bahia-logo-menu.31320790.png";